import { render, staticRenderFns } from "./castiglione-del-bosco.vue?vue&type=template&id=609fc179&scoped=true"
import script from "./castiglione-del-bosco.vue?vue&type=script&lang=js"
export * from "./castiglione-del-bosco.vue?vue&type=script&lang=js"
import style0 from "./castiglione-del-bosco.vue?vue&type=style&index=0&id=609fc179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fc179",
  null
  
)

export default component.exports